import { cn } from '../../utils/cn.js';

import Spinner from './spinner.jsx';

/**
 * Renders a Loading component with customizable options.
 *
 * @param {Object} props - The props for the Loading component.
 * @param {string} [props.pageHeight=false] - The loading message to display.
 * @param {string} [props.message] - The loading message to display.
 * @param {string} [props.iconSize] - The loader icon size.
 *
 * @return {JSX.Element} The Loading component
 */
const Loading = ({ pageHeight = false, message, iconSize = '20' }) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center',
        pageHeight && 'min-h-[70vh] justify-center',
      )}
    >
      <Spinner />
      {message ? <span className="mt-4">{message}...</span> : null}
    </div>
  );
};

export default Loading;
